var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2AccountVenueSpaceWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.21436 13.9822C6.21436 11.922 7.03275 9.94626 8.48951 8.48951C9.94626 7.03275 11.922 6.21436 13.9822 6.21436H44.0179C46.0781 6.21436 48.0539 7.03275 49.5106 8.48951C50.9674 9.94626 51.7858 11.922 51.7858 13.9822V37.2858H50.0458L43.4172 29.0001H48.6786V13.9822C48.6786 12.7461 48.1876 11.5606 47.3135 10.6866C46.4395 9.81254 45.254 9.3215 44.0179 9.3215H13.9822C12.7461 9.3215 11.5606 9.81254 10.6866 10.6866C9.81254 11.5606 9.3215 12.7461 9.3215 13.9822V29.0001H14.5829L7.95436 37.2858H6.21436V13.9822ZM38.684 40.3929H51.7858V44.0179C51.7858 46.0781 50.9674 48.0539 49.5106 49.5106C48.0539 50.9674 46.0781 51.7858 44.0179 51.7858H42.2075L41.6171 49.7682L38.684 40.3929ZM46.0666 37.2858H37.7125L35.1191 29.0001H39.438L46.0666 37.2858ZM24.5796 37.2858H34.4562L31.8649 29.0001H27.171L24.5796 37.2858ZM35.4277 40.3929H23.6081L20.3829 50.6962L20.0411 51.7858H38.9699L38.6467 50.6817L35.4277 40.3929ZM23.9147 29.0001L21.3254 37.2858H11.9315L18.5601 29.0001H23.9147ZM20.3519 40.3929H6.21436V44.0179C6.21436 46.0781 7.03275 48.0539 8.48951 49.5106C9.94626 50.9674 11.922 51.7858 13.9822 51.7858H16.7849L17.4208 49.7661L20.3519 40.3929Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2AccountVenueSpaceWhite);
export default __webpack_public_path__ + "static/media/v2-account-venue-space-white.10ca72f772abb75ab7391fca44143f14.svg";
export { ForwardRef as ReactComponent };